import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"

import * as am4core from '@amcharts/amcharts4/core';
import { color } from '@amcharts/amcharts4/.internal/core/utils/Color';

import { PieChart } from '@amcharts/amcharts4/.internal/charts/types/PieChart';
import { Legend } from '@amcharts/amcharts4/.internal/charts/Legend';
import { PieSeries } from '@amcharts/amcharts4/.internal/charts/series/PieSeries';
import ColumnCylinder from "../CylinderColumnChart/ColumnCylinder";

const COLORS = {
  'New': color('#1ABC9C'),
  'Closed': color('#FEBC77'),
  'In Progress': color('#D65DB1'),
  'On Hold': color('#2980B9'),
  'Cancelled': color('#F1C40F'),
  'default': color('#FF7043'),
  'severity 1': color("#27AE60"),
  'severity 2': color('#8DB7D7'),
  'severity 3': color("#8E44AD"),
  'severity 4': color("#FF8083"),
  'severity 5': color('#AD1457'),
};


class RadiusPieChart extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.chart = am4core.create("chartdiv", PieChart);
    this.chart.hiddenState.properties.opacity = 1;

    this.chart.innerRadius = am4core.percent(7);

    this.chart.legend = new Legend();
    this.chart.legend.position = 'bottom';
    this.chart.legend.align = 'center';
    this.chart.legend.paddingLeft = 24;
    this.chart.legend.itemContainers.template.clickable = true;
    this.chart.legend.itemContainers.template.focusable = false;
    this.chart.legend.valueLabels.template.fill = color('#CEDBDC');
    this.chart.legend.labels.template.fill = color('#CEDBDC');
    this.chart.legend.labels.template.fontSize = 14;
    this.chart.legend.labels.template.fontWeight = 'bold';
    this.chart.legend.useDefaultMarker = true;
    this.marker = this.chart.legend.markers.template.children.getIndex(0);
    this.marker.cornerRadius(12, 12, 12, 12);
    this.marker.width = 14;
    this.marker.height = 14;
    this.marker.dy = 4;
    this.marker.dx = -5;




    this.createSeries();
    this.updateChartsData();

  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.datasets !== prevProps.datasets) {
      this.updateChartsData();
    }
  }

  createSeries = () => {
    this.series = this.chart.series.push(new PieSeries());
    this.series.dataFields.value = "value";
    this.series.dataFields.radiusValue = "value2";
    this.series.dataFields.category = "key";
    this.series.slices.template.cornerRadius = 2;
    // this.series.legendSettings.valueText = '{value}';
    this.series.labels.template.text = "{category}: {value}";
    this.series.slices.template.stroke = am4core.color("#fff");
    this.series.slices.template.strokeWidth = 2;
    this.series.slices.template.strokeOpacity = 0.2;

    this.series.ticks.template.disabled = true;
    this.series.labels.template.disabled = true;

    this.series.hiddenState.properties.opacity = 1;
    this.series.hiddenState.properties.endAngle = -90;
    this.series.hiddenState.properties.startAngle = -90;

    this.series.colors.list = [
      am4core.color("#FF7043"),
      am4core.color("#845EC2"),
      am4core.color("#AD1457"),
      am4core.color("#66BB6A"),
      am4core.color("#E74C3C"),
      am4core.color("#F9F871")
    ];

    let filter = this.series.filters.push(new am4core.DropShadowFilter());
    filter.color = am4core.color("#2980B9");
    filter.dx = 10;
    filter.dy = 0;
    filter.blur = 10;
    filter.opacity = 0.5;

  }

  updateChartsData = () => {
    const { datasets } = this.props;

    const normalizeText = {
      new: 'New',
      closed: "Closed",
      inProgress: "In Progress",
      onHold: "On Hold",
      resolved: "Resolved",
      cancelled: "Cancelled"
    }

    if (!datasets) {
      return null;
    }

    const newDataset = Object.entries(datasets).map(([key, value]) => {
      return {
        key: normalizeText[key],
        color: COLORS[key],
        value: value,
        value2: value * 2
      }
    })

    this.chart.data = newDataset;
    this.chart.legend.data = newDataset.map((type) => ({
      name: type.key,
      fill: COLORS[type.key]
    }))
  }

  render() {
    return (
      <div>
        <div id="chartdiv" style={{ width: '100%', height: "520px" }}></div>
      </div>
    )
  }
}

RadiusPieChart.propTypes = {
  datasets: PropTypes.array,
  position : PropTypes.string
}

ColumnCylinder.defaultProps = {
  position: 'bottom',
};

export default RadiusPieChart